export default __webpack_public_path__ + "static/media/project-work.b89280e0.svg";